import { Box, styled, Typography } from '@mui/material';

export const Title = styled(Typography)<{ disableSpacing?: boolean }>`
  text-align: center;
  font-size: 30px;
  line-height: 34px;
  font-weight: 700;
  margin-bottom: ${({ disableSpacing }) => (disableSpacing ? 0 : 40)}px;

  ${({ theme }) => theme.breakpoints.up('md')} {
    margin-bottom: ${({ disableSpacing }) => (disableSpacing ? 0 : 24)}px;
    font-size: 36px;
    line-height: 43px;
  }
`;

export const SubTitle = styled(Typography)`
  font-size: 24px;
  line-height: 24px;
  text-align: center;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 700;

  ${({ theme }) => theme.breakpoints.up('md')} {
    font-size: 30px;
    line-height: 34px;
  }
`;

export const Container = styled(Box)`
  max-width: 1136px;
  margin: 0 auto;
  padding-left: 24px;
  padding-right: 24px;

  ${({ theme }) => theme.breakpoints.up('lg')} {
    padding-left: 0;
    padding-right: 0px;
  }
`;
